export default __webpack_public_path__ + "static/media/blue_pawn.fe6af0be.png";